


























// Importing functions
import {getRegions} from '@/ts/ekatte/get-regions';
import {getMunicipalities} from '@/ts/ekatte/get-municipalities';
import {getTowns} from '@/ts/ekatte/get-towns';
import {getTown} from '@/ts/ekatte/get-town';

export default {
    name: 'TheTownSelect',
    components: {},
    props: {
        value: String,
        vertical: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            provinces: Array(),
            municipalities: Array(),
            towns: Array(),
            municipality: String(''),
            province: String(''),
        };
    },
    mounted() {
        getRegions().then((response) => {
            this.provinces = response;
            if (this.value !== '') {
                getTown(this.value).then((data: any) => {
                    this.municipality = data.municipality;
                    this.province = data.province;
                });
            }
        });
    },
    watch: {
        value() {
            getRegions().then((response) => {
                this.provinces = response;
                if (this.value !== '') {
                    getTown(this.value).then((data: any) => {
                        this.municipality = data.municipality;
                        this.province = data.province;
                    });
                }
            });
        },
        province(value) {
            if (value !== '') {
                this.towns = [];
                this.municipalities = [];
                getMunicipalities(value).then((result) => {
                    this.municipalities = result;
                });
            }
        },
        municipality(value) {
            if (value !== '' && value !== undefined) {
                this.towns = [];
                getTowns(value).then((result) => {
                    this.towns = result;
                });
            }
        },
    },
    methods: {
        updateTown(value) {
            this.$emit('input', value);
            const element = this.towns.find((item) => item.value === value);
            if (element !== undefined) {
                this.$emit('town', element.text);
            }
        },
    },
};
